export default "__VITE_ASSET__DB2fgDUv__"